import React from 'react';
import { COLORS } from 'shared/design-system/settings/variables/Colors';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import styled from 'styled-components';

const BaseTooltipStyles = styled.div`
  padding: 24px;
  ul {
    padding-left: 16px;
    color: ${COLORS.blackPure};
    margin-top: 16px;
    margin-bottom: 0;
    li {
      margin-bottom: 10px;
    }
    li:last-child {
      margin-bottom: 0px;
    }
    ul {
      margin-top: 8px;
      list-style-type: disc;
    }
  }
`;

export const AgeTooltip: JSX.Element = (
  <BaseTooltipStyles>
    <TrueImpactText variant="body-bold">Groups included</TrueImpactText>
    <ul>
      <li>
        <TrueImpactText variant="body-bold">Adults</TrueImpactText>
        <ul>
          <li>
            <TrueImpactText>Adults (19 and older)</TrueImpactText>
          </li>
          <li>
            <TrueImpactText>Seniors (64+)</TrueImpactText>
          </li>
        </ul>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          Children and youth (birth to 18 years)
        </TrueImpactText>
        <ul className="sub-ul">
          <li>
            <TrueImpactText>Children (birth to 9 years)</TrueImpactText>
          </li>
          <li>
            <TrueImpactText>Youth (10 to 18 years)</TrueImpactText>
          </li>
        </ul>
      </li>
    </ul>
  </BaseTooltipStyles>
);

export const EthnicTooltip: JSX.Element = (
  <BaseTooltipStyles>
    <TrueImpactText variant="body-bold">Groups included</TrueImpactText>
    <ul>
      <li>
        <TrueImpactText variant="body-bold">
          People of African descent
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          People of Latin American descent
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          People of European descent
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Multiracial people</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          People of Asian descent
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Indigenous peoples</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          People of Middle Eastern descent
        </TrueImpactText>
      </li>
    </ul>
  </BaseTooltipStyles>
);

export const GenderTooltip: JSX.Element = (
  <BaseTooltipStyles>
    <TrueImpactText variant="body-bold">Groups included</TrueImpactText>
    <ul>
      <li>
        <TrueImpactText variant="body-bold">Women and girls</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Men and boys</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">LGBTQIA+ people</TrueImpactText>
      </li>
    </ul>
  </BaseTooltipStyles>
);

export const HealthTooltip: JSX.Element = (
  <BaseTooltipStyles>
    <TrueImpactText variant="body-bold">Groups included</TrueImpactText>
    <ul>
      <li>
        <TrueImpactText variant="body-bold">
          People with disabilities
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          People with diseases and illnesses
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          People with substance use disorder
        </TrueImpactText>
      </li>
    </ul>
  </BaseTooltipStyles>
);

export const SocialTooltip: JSX.Element = (
  <BaseTooltipStyles>
    <TrueImpactText variant="body-bold">Groups included</TrueImpactText>
    <ul>
      <li>
        <TrueImpactText variant="body-bold">
          Immigrants, migrants, and refugees
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          Economically disadvantaged people
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Youth</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Homeless people</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          Extremely poor people
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          Victims and oppressed people
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Incarcerated people</TrueImpactText>
      </li>
    </ul>
  </BaseTooltipStyles>
);

export const WorkTooltip: JSX.Element = (
  <BaseTooltipStyles>
    <TrueImpactText variant="body-bold">Groups included</TrueImpactText>
    <ul>
      <li>
        <TrueImpactText variant="body-bold">Students</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Unemployed people</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Veterans</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          Self-employed people
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Retired people</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Domestic workers</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Military personnel</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Farmers</TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          Artists and performers
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">
          Emergency responders
        </TrueImpactText>
      </li>
      <li>
        <TrueImpactText variant="body-bold">Teachers</TrueImpactText>
      </li>
    </ul>
  </BaseTooltipStyles>
);
